export const CUSTOM_OFFER_CANCELLATION_REASON_CODES = {
  foundCheaperDeal: 'found_cheaper_deal',
  changeInTravelPlans: 'change_in_travel_plans',
  personalReasons: 'personal_reasons',
  financialConstraints: 'financial_constraints',
  travelRestrictions: 'travel_restrictions',
  betterLoyaltyProgramOrRewards: 'better_loyalty_program_or_rewards',
  other: 'other',
} as const

export const CUSTOM_OFFER_CANCELLATION_REASON_COMMENT_BY_CODE: Record<string, string> = {
  [CUSTOM_OFFER_CANCELLATION_REASON_CODES.foundCheaperDeal]: 'Found a cheaper deal',
  [CUSTOM_OFFER_CANCELLATION_REASON_CODES.changeInTravelPlans]: 'Change in travel plans',
  [CUSTOM_OFFER_CANCELLATION_REASON_CODES.personalReasons]: 'Personal reasons',
  [CUSTOM_OFFER_CANCELLATION_REASON_CODES.financialConstraints]: 'Financial constraints',
  [CUSTOM_OFFER_CANCELLATION_REASON_CODES.travelRestrictions]: 'Travel restrictions',
  [CUSTOM_OFFER_CANCELLATION_REASON_CODES.betterLoyaltyProgramOrRewards]: 'Better loyalty program or rewards',
}
